import React, { useEffect, useState } from 'react'
import { useTheme } from '../../context/ThemeContext'
import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useNavigate } from 'react-router-dom'
import { APIGetActiveEarlyWarningCount } from '../../services/DashboardService'
import { useNotification } from '../../context/NotificationContext'

type AcknowledgeCountCardPropsType = {
    width?: string;
    height?: string;
    backgroundColor?: string;
    gridArea: string;
}

const AcknowledgeCountCard = (props: AcknowledgeCountCardPropsType) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL
    const { theme } = useTheme()
    const navigate = useNavigate()

    const [incidentCount, setIncidentCount] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [isNeedReloading, setIsNeedReloading] = useState<boolean>(false)
    
    const { notifications, unreadCount, removeNotification } = useNotification()

    useEffect(() => {
        if (notifications.length > 0) 
        {
            const latest = notifications[0]
            //console.log(`🔔 New: ${latest.title} - ${latest.message}`)
            switch (latest.title)
            {
                case 'NEW_ACKNOWLEDGEMENT':
                    setIsNeedReloading(prevState => !prevState)
                    break

            }
        }
    }, [notifications])

    useEffect(() => {
        setIsLoading(true)
        const token = localStorage.getItem("access_token");
        fetch(`${BASE_URL}/acknowledge/api/v1/records/count/acked`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
        .then((res) => res.json())
        .then((data) => {
            const response = data as number
            setIncidentCount(response)
        })
        .catch((err) => console.error("Error fetching roles:", err))
        .finally(() => {
            setIsLoading(false)
        })
        setIsLoading(false)
    }, [isNeedReloading])

    return (
        <div className='dashboard-incident-count-card' style={{width: props.width ? props.width : '100%', height: props.height ? props.height : '5rem', backgroundColor: props.backgroundColor ? props.backgroundColor : 'var(--color-side-menu-bg)', gridArea: props.gridArea, border: theme === 'light' ? 'solid 1px gray' : ''}} onClick={(e) => navigate('/sm/early_warning/acknowledgement')}>
            {isLoading ? (
                <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} />
                ) : (
                    <span className="count">{incidentCount}</span>
                )
            }
            <span className="name">Acknowledge</span>
        </div>
    )
}

export default AcknowledgeCountCard